import { render, staticRenderFns } from "./num-selector.vue?vue&type=template&id=03ffca4b"
import script from "./num-selector.vue?vue&type=script&lang=ts"
export * from "./num-selector.vue?vue&type=script&lang=ts"
import style0 from "./num-selector.vue?vue&type=style&index=0&id=03ffca4b&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports